import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Card,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DropZone from 'react-dropzone';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal, ImageCard } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import Selector from './Selector';
import Utility from './Utility';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';

class Dolgozo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: false,
      dolgozok: [],
      dolgozoSelectedObj: {},
      img: null,
      insert: true,
      modalDolgozo: false,
      modalDolgozoConfirm: false,
      modalDolgozoDelete: false,
      modalDolgozoView: false,
      szolgaltatasList: [],
      szolgaltatasokJSON: [],
      szolgaltatasOptions: [],
      szolgaltatasSelected: null,
      szolgaltatasViewList: [],
      teremJSON: [],
      teremList: [],
      teremOptions: [],
      teremSelected: null,
      teremViewList: [],
      visszaigazolasCheck: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '2' && this.props.activeTab === '2') {
      this.updateTable();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['IDOPONT_DOLGOZO'], true);
  }

  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' }, () => {
      Service.listDolgozo(false, (err, res) => {
        if (!err) {
          let status = res[0].length == 0 ? 'DATA' : 'TABL';
          this.setState({ dolgozok: res[0], tableStatus: status });
        } else {
          this.setState({ tableStatus: 'NETW' });
        }
      });
      Service.listSzolgaltatas(null, null, (err, res) => {
        if (!err) {
          this.setState({ szolgaltatasokJSON: res[0] }, () => {
            this.convertSzolgaltatasJsonToOptions();
          });
        }
      });
      Service.listTerem((err, res) => {
        if (!err) {
          this.setState({ teremJSON: res[0] }, () => {
            this.convertTeremJsonToOptions();
          });
        }
      });
    });
  }

  toggleDolgozoView = () => {
    this.setState((prevState) => { return { modalDolgozoView: !prevState.modalDolgozoView } });
  }

  toggleDolgozo = () => {
    this.setState((prevState) => { return { modalDolgozo: !prevState.modalDolgozo }; });
  }

  toggleDolgozoTorles = () => {
    this.setState((prevState) => { return { modalDolgozoDelete: !prevState.modalDolgozoDelete }; });
  }

  toggleDolgozoConfirm = () => {
    this.setState((prevState) => { return { modalDolgozoConfirm: !prevState.modalDolgozoConfirm }; });
  }

  handleDolgozoAddClick = () => {
    this.setState({ insert: true, szolgaltatasList: [], teremList: [], szolgaltatasSelected: null, teremSelected: null, visszaigazolasCheck: false, img: null });
    this.toggleDolgozo();
  }

  handleDolgozoViewClick = (id) => {
    this.setState({ dataLoaded: false }, () => {
      Service.getDolgozo(id, (err, res) => {
        if (!err) {
          let szolgaltatasViewList = [];
          let teremViewList = [];
          for (let szolgaltatas of res[0].szolgaltatasok) {
            for (let option of this.state.szolgaltatasOptions) {
              if (szolgaltatas.szolgaltatasid == option.props.value) {
                Utility.insertByOrder(szolgaltatasViewList, <div>{option.props.children + Utility.convertCheckBooleanToString(szolgaltatas.automata)}<br /></div>);
                break;
              }
            }
          }
          for (let teremid of res[0].teremidk) {
            for (let option of this.state.teremOptions) {
              if (teremid == option.props.value) {
                Utility.insertByOrder(teremViewList, <div>{option.props.children}<br /></div>);
                break;
              }
            }
          }
          this.setState({ dolgozoSelectedObj: res[0], img: res[0].img, szolgaltatasViewList, teremViewList, dataLoaded: true });
        }
      });
    });
    this.toggleDolgozoView();
  }

  handleDolgozoEditClick = (id) => {
    this.setState({ dataLoaded: false }, () => {
      Service.getDolgozo(id, (err, res) => {
        if (!err) {
          this.setState({ dolgozoSelectedObj: res[0], img: res[0].img, dataLoaded: true });
        }
      });
      this.setState((prevState) => {
        const dolgozo = prevState.dolgozok.find(element => element.id === id);
        let szolgaltatasListAlt = [];
        for (let option of prevState.szolgaltatasOptions) {
          for (let szolgaltatas of dolgozo.szolgaltatasok) {
            if (szolgaltatas.szolgaltatasid == option.props.value) {
              szolgaltatasListAlt.push(
                <option value={option.props.value}>
                  {option.props.children + Utility.convertCheckBooleanToString(szolgaltatas.automata)}
                </option>
              );
            }
          }
        }
        let teremListAlt = prevState.teremOptions.filter((option) => { return dolgozo.teremidk.includes(option.props.value) });
        return {
          dolgozoSelectedObj: dolgozo, insert: false, szolgaltatasList: szolgaltatasListAlt, teremList: teremListAlt,
          szolgaltatasSelected: null, teremSelected: null, visszaigazolasCheck: false
        };
      });
      this.toggleDolgozo();
    });
  }

  handleDolgozoDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleDolgozoTorles();
  }

  handleSzolgaltatasSetState = (obj) => {
    let obj2 = {};
    // Azért van így összerakva az obj2, hogy ne kerüljön felülírásra az az érték, ami nincs az obj-ban
    if (obj.hasOwnProperty('elementSelected'))
      obj2.szolgaltatasSelected = obj.elementSelected
    if (obj.hasOwnProperty('list'))
      obj2.szolgaltatasList = obj.list;
    if (obj.hasOwnProperty('options'))
      obj2.szolgaltatasOptions = obj.options;
    if (obj.hasOwnProperty('visszaigazolasCheck'))
      obj2.visszaigazolasCheck = obj.visszaigazolasCheck;
    this.setState(obj2);
  }

  handleTeremSetState = (obj) => {
    let obj2 = {};
    if (obj.hasOwnProperty('elementSelected'))
      obj2.teremSelected = obj.elementSelected
    if (obj.hasOwnProperty('list'))
      obj2.teremList = obj.list;
    if (obj.hasOwnProperty('options'))
      obj2.teremOptions = obj.options;
    this.setState(obj2);
  }

  iconFormatter = (cell) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleDolgozoViewClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {
          this.hasRoleKarb()
            ? (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleDolgozoEditClick(cell)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDolgozoDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
              </React.Fragment>
            )
            : <div />
        }
      </div>
    );
  }

  hasCheck = (string) => {
    return string.substr(string.length - 2, 1) == '✓';
  }

  insertStateFieldsIntoObject = (dolgozoObj) => {
    dolgozoObj.img = this.state.img;
    dolgozoObj.szolgaltatasok = this.state.szolgaltatasList.map((option) => {
      return { szolgaltatasid: option.props.value, automata: this.hasCheck(option.props.children) }
    });
    dolgozoObj.teremidk = this.state.teremList.map((option) => { return option.props.value });
  }

  addDolgozo = (event, dolgozoObj) => {
    dolgozoObj.kikuld = dolgozoObj.kikuld || false;
    this.insertStateFieldsIntoObject(dolgozoObj);
    Service.addDolgozo(dolgozoObj, (err) => {
      if (!err) {
        this.toggleDolgozo();
        this.updateTable();
        this.props.globals.addSuccess('Dolgozó hozzáadva!');
      }
    });
  }

  confirmModifyDolgozo = (event, dolgozoObj) => {
    dolgozoObj.id = this.state.dolgozoSelectedObj.id;
    dolgozoObj.kikuld = dolgozoObj.kikuld || false;
    this.insertStateFieldsIntoObject(dolgozoObj);
    this.setState({ dolgozoObj }, () => {
      Service.checkForFoglalasSor(dolgozoObj, (err, res) => {
        if (!err) {
          if (res[0] == true) {
            this.toggleDolgozoConfirm();
          } else {
            this.modifyDolgozo();
          }
        }
      });
    });
  }

  modifyDolgozo = () => {
    Service.editDolgozo(this.state.dolgozoObj, (err) => {
      if (!err) {
        this.toggleDolgozo();
        this.updateTable();
        this.props.globals.addSuccess('Dolgozó módosítva!');
      }
    });
  }

  deleteDolgozo = () => {
    this.toggleDolgozoTorles();
    Service.deleteDolgozo(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Dolgozó törölve!');
      }
    });
  }

  convertSzolgaltatasJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.szolgaltatasokJSON);
    array.sort((a, b) => { return a.nev.localeCompare(b.nev) });
    for (let szolgaltatas of array) {
      mezok.push(<option value={szolgaltatas.id}>{szolgaltatas.nev + ' (' + szolgaltatas.idotartam + ')'}</option>);
    }
    this.setState({ szolgaltatasOptions: mezok });
  }

  convertTeremJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.teremJSON);
    array.sort((a, b) => { return a.nev.localeCompare(b.nev) });
    for (let terem of array) {
      mezok.push(<option value={terem.id}>{terem.nev + ' (' + terem.azonosito + ')'}</option>);
    }
    this.setState({ teremOptions: mezok });
  }

  loadSzolgaltatasElement = (obj) => {
    this.setState({ szolgaltatasSelected: obj });
  }

  loadTeremElement = (obj) => {
    this.setState({ teremSelected: obj });
  }

  onDropPlakat = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files;
        files = this.state.img || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
        });
        this.setState({ img: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  statusFormatter = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Aktív</span>;
      case false:
        return <span className="badge badge-default">Inaktív</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'telefonszam',
        text: 'Telefonszám',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
      },
      {
        dataField: 'email',
        text: 'E-mail cím',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.dolgozok}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
    }
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  renderDataView = () => {
    const {
      dolgozoSelectedObj,
      img,
      szolgaltatasViewList,
      teremViewList
    } = this.state;
    return this.state.dataLoaded ? (
      <div>
        <b>Név: </b>{dolgozoSelectedObj && dolgozoSelectedObj.nev}<br />
        <b>E-mail cím: </b>{dolgozoSelectedObj && dolgozoSelectedObj.email}<br />
        <b>Telefonszám: </b>{dolgozoSelectedObj && dolgozoSelectedObj.telefonszam}<br />
        <b>Publikus: </b>{dolgozoSelectedObj && dolgozoSelectedObj.kikuld ? 'Igen' : 'Nem'}<br />
        <b>Megjegyzés: </b>{dolgozoSelectedObj && dolgozoSelectedObj.megjegyzes}<br />
        <b>Leírás:</b><br />{dolgozoSelectedObj && dolgozoSelectedObj.leiras}<br />
        <br />
        <b>Szolgáltatások (Visszaigazolás): </b>{szolgaltatasViewList}<br />
        <b>Termek: </b>{teremViewList}<br />
        {img ? <div>
          <h6>Kép:</h6><br />
          <Card inverse style={{ backgroundColor: "#000" }} >
            <CardImg
              src={img.src ? img.src : "data:image/bmp;base64," + img.content}
            />
          </Card>
        </div>
          : <div />
        }
      </div>
    ) : this.renderLoader();
  }

  render() {
    const {
      dataLoaded,
      dolgozoSelectedObj,
      img,
      insert,
      modalDolgozo,
      modalDolgozoConfirm,
      modalDolgozoDelete,
      modalDolgozoView,
      szolgaltatasList,
      szolgaltatasOptions,
      szolgaltatasSelected,
      teremList,
      teremOptions,
      teremSelected,
      visszaigazolasCheck,
    } = this.state;
    const szolgaltatasStateData = {
      elementSelected: szolgaltatasSelected,
      list: szolgaltatasList,
      options: szolgaltatasOptions,
      visszaigazolasCheck: visszaigazolasCheck,
    };
    const teremStateData = {
      elementSelected: teremSelected,
      list: teremList,
      options: teremOptions,
    };
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb() ?
              (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleDolgozoAddClick}>Új dolgozó</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.renderState()}
        <Modal isOpen={modalDolgozo} toggle={this.toggleDolgozo} className={this.props.className} backdrop="static" size="lg">
          <RFForm
            modal
            title={"Dolgozó " + (insert ? "felvétel" : "módosítás")}
            onSubmit={insert ? this.addDolgozo : this.confirmModifyDolgozo}
            footer={
              <>
                <Button color="primary">{'Mentés'}</Button>{' '}
                <Button color="secondary" onClick={this.toggleDolgozo}>Mégsem</Button>
              </>
            }
            >
              {dataLoaded || insert ?
                <div>
                  <div className="row">
                    <div className='col-md-6 row align-self-start'>
                      <div className="col-md-6">
                        <RFField
                          label="Név: *"
                          name="nev"
                          validate={value => value && value.length > 100 && "Maximum hossz: 100 karakter"}
                          value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.nev : ''}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <RFField
                          label="E-mail cím:"
                          name="email"
                          value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.email : ''}
                        />
                      </div>
                      <div className="col-md-6">
                        <RFField
                          label="Telefonszám:"
                          name="telefonszam"
                          validate={value => value && value.length > 24 && "Maximum hossz: 24 karakter"}
                          value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.telefonszam : ''}
                        />
                      </div>
                      <div className='col-md-auto' style={{ marginTop: '35px' }}>
                        <RFField
                          label="Publikus"
                          type="checkbox"
                          name="kikuld"
                          value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.kikuld : false}
                        />
                      </div>
                      <div className='col' />
                      <RFField
                        label="Megjegyzés:"
                        style={{ height: '80px' }}
                        type="textarea"
                        name={"megjegyzes"}
                        value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.megjegyzes : ''}
                      />
                      <RFField
                        label="Leírás:"
                        style={{ height: '120px' }}
                        type="textarea"
                        name={"leiras"}
                        value={!insert && dolgozoSelectedObj ? dolgozoSelectedObj.leiras : ''}
                      />
                    </div>
                    <div className="col-md-6" style={{ marginTop: '29px', paddingLeft: 0 }}>
                      <div className="col-md-12">
                        {!img &&
                          <DropZone onDrop={this.onDropPlakat} className="custom-dropzone" style={{ marginTop: '29px', paddingLeft: 0 }}>
                            {({getRootProps, getInputProps}) => (
                                <div {...getRootProps({ className: 'custom-dropzone'})}>
                                  <input {...getInputProps()} />
                                  <div className="dropzone-text">
                                    {'Kép feltöltése!'}
                                  </div>
                                </div>
                            )}
                          </DropZone>
                        }
                        {img &&
                          <ImageCard
                            key={"0"}
                            mime={img.mime}
                            content={img.content}
                            src={img.src}
                            poster
                            // title={item.docname}
                            main={img.main}
                            // style={{height: "200px"}}
                            // onViewClick={e => this.toggleJelenetKepModal(idx)}
                            // onMainImageClick={e =>{
                            //   formJelenetkepek.forEach((jK, idx2) => {
                            //     if(idx == idx2)
                            //       jK.main = true;
                            //     else
                            //       jK.main = false;
                            //   });
                            //   this.setState(formJelenetkepek);
                            // }}
                            onDeleteClick={() => { this.setState({ img: null }) }}
                            // noStyle
                          />
                        }
                      </div>
                    </div>
                    <div className='col-md-12 row no-gutters'>
                      <div className='col-md-6'>
                        <Selector
                          type="SZOLGALTATAS"
                          setState={this.handleSzolgaltatasSetState}
                          loadElementSelected={this.loadSzolgaltatasElement}
                          stateData={szolgaltatasStateData}
                          listLabel='Szolgáltatások (Visszaigazolás)'
                          selectorDefaultOptionName='Válassz szolgáltatást...'
                          selectorLabel='Szolgáltatás (időtartam percben)'
                          selectorTitle='Szolgáltatások kiválasztása'
                          useCheckbox
                        />
                      </div>
                      <div className='col-md-6 pl-1'>
                        <Selector
                          type="TEREM"
                          setState={this.handleTeremSetState}
                          loadElementSelected={this.loadTeremElement}
                          stateData={teremStateData}
                          listLabel='Termek'
                          selectorDefaultOptionName='Válassz termet...'
                          selectorLabel='Terem'
                          selectorTitle='Szolgáltatás helyszíne'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                : this.renderLoader()
              }
          </RFForm>
        </Modal>
        <Modal isOpen={modalDolgozoDelete} toggle={this.toggleDolgozoTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a dolgozót?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteDolgozo}>OK</Button>
            <Button color="secondary" onClick={this.toggleDolgozoTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modalDolgozoView} toggle={this.toggleDolgozoView} className={this.props.className} backdrop="static">
          <ModalHeader>Megtekintés</ModalHeader>
          <ModalBody>{this.renderDataView()}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleDolgozoView}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modalDolgozoConfirm} toggle={this.toggleDolgozoConfirm} className={this.props.className} backdrop="static">
          <ModalHeader>Megerősítés</ModalHeader>
          <ModalBody>A törölt szolgáltatások közül legalább egyhez már tartozik aktiválatlan foglalás. Módosításkor ezek a foglalások törlésre kerülnek. Biztosan módosítani akarja a dolgozót?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => { this.modifyDolgozo(); this.toggleDolgozoConfirm(); }}>Igen</Button>
            <Button color="secondary" onClick={this.toggleDolgozoConfirm}>Nem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default Dolgozo;
